// extracted by mini-css-extract-plugin
module.exports = {"heading":"enterMobile_heading__1uQ83","icon":"enterMobile_icon__JBmuh","container":"enterMobile_container__2kpKb"};